import React from 'react';
import './App.css';
import Navbar from './components/Navbar/Navbar';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './components/pages/Home';
import Footer from './components/Footer/Footer';
import HelperAvatar from './components/HelperAvatar/HelperAvatar';
import { API_KEY, SPREADSHEET_ID } from './constants';
import axios from 'axios';
import Loading from './components/Loading/Loading';
import Login from './components/pages/Login/Login';
import Dashboard from './components/pages/Dashboard/Dashboard';
import PrivateInversorRoute from './components/PrivateInversorRoute';

function App() {
  const [data, setData] = React.useState([]);
  React.useEffect(() => {
    const sheet = 'WEBPAGE';
    axios
      .get(
        `https://sheets.googleapis.com/v4/spreadsheets/${SPREADSHEET_ID}/values/${sheet}?key=${API_KEY}`
      )
      .then((res) => {
        setData(res.data.values || []);
      });
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/dashboard"
          element={
            <PrivateInversorRoute>
              <Dashboard />
            </PrivateInversorRoute>
          }
        />
        <Route
          path="/"
          element={
            data.length > 0 ? (
              <>
                <Navbar data={data} />
                <Home data={data} />
                <Footer data={data} />
                <HelperAvatar data={data} />
              </>
            ) : (
              <Loading />
            )
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
